import clsx from 'clsx';
import styles from './CardListLayout.module.css';

export function CardListLayout({ children, className }) {
  return <div className={clsx(styles.body, className)}>{children}</div>;
}

export function CardList({ children, className, ...rest }) {
  return (
    <div className={clsx(styles.list, className)} role="list" {...rest}>
      {children}
    </div>
  );
}

export function CardListRow({ children, className, ...rest }) {
  return (
    <div className={clsx(styles.row, className)} role="listitem" {...rest}>
      {children}
    </div>
  );
}
